import { useEffect, useState, useRef } from "react";
import useGetRole from "../hooks/useGetRole";
import { useSetToken } from "../hooks/useSetToken";
import useLogin from "hooks/useLogin";
import useMsalB2C from "./useMsalB2C";
function useLayout() {
  const { loginRequest } = useMsalB2C();
  const userRole = useGetRole.getRole();
  const { isImpersonation, impersonationAppName } = useGetRole;
  const [rolePermision, setRolePermision] = useState("");
  const { isAuthenticate } = useLogin();
  const hasHandledRedirect = useRef(false);


  useSetToken();
  useEffect(() => {
    // Only handle redirect once
    if (!hasHandledRedirect.current) {
      hasHandledRedirect.current = true;

      // Normal-login recovery lives in the hook; this layout must not start impersonation.
      loginRequest().catch((error: unknown) => {
        console.error("MSAL login error:", error);
      });
    }

    if (typeof userRole === "string" && rolePermision !== userRole) {
      setRolePermision(userRole);
    }

  }, [isAuthenticate, userRole, loginRequest, rolePermision]);

  return {
    userRole,
    rolePermision,
    isAuthenticate,
    isImpersonation,
    impersonationAppName
  };
}

export default useLayout;
